/* eslint-disable import/prefer-default-export */
export const opensInNewTab = 'opens in a new tab';
